// extracted by mini-css-extract-plugin
module.exports = {"list":"TagList_list__4YRwG","item":"TagList_item__i_ha5","icon":"TagList_icon__iLHmZ","text":"TagList_text__sx69S","count":"TagList_count__aOQ7V"};